var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.myRun.status === 'D')?_c('RunOutput'):_vm._e(),(_vm.myRun.status === 'B' || _vm.myRun.status === 'C' || _vm.myRun.status === 'F')?_c('RunInput'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }